import { JSX } from "react";

type ErrorValue<T extends boolean = false> = 
  T extends false ?
  {
    passed_validation: boolean;
    jsx_element?: false;
    message: string;
  }
  :
  {
    passed_validation: boolean;
    jsx_element: true;
    message: {element: JSX.Element, text: string};
  }

export type ImprovedErrors<Keys extends string = string, JSXKey extends Keys | null = null> = {
  [K in Keys]: ErrorValue<K extends JSXKey ? true : false>;
}



export function checkAllFieldsImproved(forms: any, optionalFields: string[] = []) {
    let error = false;
    for(const field in forms.errors){
        if(!forms.errors[field].passed_validation && !optionalFields.includes(field)){
            error = true;
            break;
        }
    }
    return error;
}

export const isRequired = (field_value: string | number): boolean => {
    if (typeof field_value === 'string' && field_value.trim().length < 1) {
        return true;
    } else if (typeof field_value == 'number' && field_value < 1) {
        return true;
    } else if (typeof field_value == 'undefined') {
        return true;
    }
    return false;
}

export const isEmail = (field_value: string): boolean => {
    if (!field_value.match(emailRegex())) {
        return false;
    }
    return true;
}

export const hasSpecialChars = (field_value: string): boolean => {
    if (field_value.trim() !== field_value.trim().replace(/[^\w\s.,;?!-]|[ĐđŠšČčĆćŽž]/g, '')) {
        return true;
    }
    return false;
}

export const hasLength = (field_value: string): boolean => {
    if (field_value.length < 8) {
        return false;
    }
    return true;
}

export const isFormatNumber = (field_value: string): boolean => {
    let regex = /^(?:\+41|0|0041)(7[5-9])\d{7}$/;
    let clear_phone = field_value;
    if(field_value == '+411111111' || field_value == '+4915310402995'){
        return true;
    }
    // if (field_value.startsWith('+41')) {
    //     regex = /^\+417[5-9]\d{6,7}$/;
    //     clear_phone = field_value.replace(/[^\d+]/g, '');
    // } else if (field_value.startsWith('41')) {
    //     regex = /^417[5-9]\d{6,7}$/;
    //     clear_phone = field_value;
    // } else {
    //     regex = /^07[5-9]\d{6,7}$/;
    //     clear_phone = field_value.replace(/[^\d]/g, '');
    // }
    return regex.test(clear_phone);
}

export const formatPhoneNumber = (phone_number: string, start_number?: boolean): string => {
    let formatedNumber: string = phone_number;
    if(start_number && formatedNumber.startsWith('+41')){
        formatedNumber = formatedNumber.replace('+41', '0');
    }
    if (formatedNumber.startsWith('07') && !start_number) {
        formatedNumber = formatedNumber.replace(formatedNumber.slice(0, 1), '+41');
    }
    if (formatedNumber.startsWith('0041') && !start_number) {
        formatedNumber = formatedNumber.replace(formatedNumber.slice(0, 4), '+41');
    }
    return formatedNumber;
}

export function emailRegex() {
    return new RegExp("^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$");
}

export const isLinkedIn = (field_value: string): boolean => {
    const regex = /^((https?:\/\/)?((www|\w\w)\.)?linkedin\.com\/)((([\w]{2,3})?)|([^\/]+\/(([\w|\d-&#?=])+\/?){1,}))$/;
    return regex.test(field_value);
}

export const isUrl = (field_value: string): boolean => {
    const regex = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;
    return regex.test(field_value);
}


export const isDateFormat = (field_value: string): boolean => {
    const regex = /^[0-3][0-9].\/[0-1][0-9].\/[1-2][0-9]{3}$/;
    return regex.test(field_value);
}

export const isValidDate = (field_value: string): {valid: boolean, message: string} => {
    let valid = true;
    let message = '';
    let ultimateDay = 0;
    let day = Number(field_value.slice(0, 2));
    let month = Number(field_value.slice(3, 5));
    let year = Number(field_value.slice(6));
    let currentYear = new Date().getFullYear();
    let currentMonth = new Date().getMonth();
    let currentDay = new Date().getDate();

    switch(month){
        case 1:
        case 3:
        case 5:
        case 7:
        case 8:
        case 10:
        case 12: {
            ultimateDay = 31;
            break;
        }
        case 4:
        case 6:
        case 9:
        case 11: {
            ultimateDay = 30;
            break;
        }
        case 2: {
            if(year % 4 == 0){
                ultimateDay = 29;
            }else{
                ultimateDay = 28;
            }
            break;
        }
        default: {
            valid = false;
            break;
        }
    }
    if(day > ultimateDay || month > 12){
        valid = false;
        message = 'error_invalid_date';
    }

    if (year > currentYear - 18) {
        valid = false;
        message = 'error_under_age';
    } else if(year == currentYear - 18) {
        if(month > currentMonth + 1){
            valid = false;
            message = 'error_under_age';
        }else if(month == currentMonth + 1){
            if(day > currentDay){
                valid = false;
                message = 'error_under_age';
            }
        }
    }

    return { valid: valid, message: message};
}

export const isLetters = (field_value: string) => {
    const regex = /^[a-zA-Z\s]+$/;
    return regex.test(field_value);
}

export const isNumbers = (field_value: string) => {
    const regex = /^[\d ]*$/;
    return regex.test(field_value);
}

export const isStreet = (field_value: string) => {
    const regex = /^([-a-zžćčđšA-ZĐŠĆŽČ_0-9.]+)( [-a-zžćčđšA-ZĐŠĆŽČ_0-9.]+)*$/;
    return regex.test(field_value);
}

export const streetLength = (field_value: string): boolean => {
    if (field_value.length <= 50) {
        return false;
    }
    return true;
}

export const isStreetNumber = (field_value: string) => {
    const regex = /^((bb|BB|b.b.|B.B.)|(\d(-\d){0,1}[a-zžćčđšA-ZĐŠĆŽČ_0-9]{0,2}))$/
    return regex.test(field_value);
}

export const streetNumberLength = (field_value: string): boolean => {
    if (field_value.length <= 10) {
        return false;
    }
    return true;
}

export const validateAllFields = (form: Record<string, string>, optionalFields: string[]): boolean => {
    let error = false;
    for (let [key, value] of Object.entries(form)) {
        if (typeof value !== 'undefined' && (value.length === 0 || !value) && !optionalFields.includes(key)) {
            form.errors[key] = 'error_is_required_field';
            error = true;
        }
    }
    return error;
}

export const onInputChangeTextColor = (element: HTMLInputElement, state: string, className?: string) => {
    if(element.value == state){
        element.parentElement?.classList.add(className ?? '');
    }else{
        element.parentElement?.classList.remove(className ?? '');
    }
}

export interface FieldError{
    error: boolean,
    message: string
}